// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CellContent {
    text-overflow: ellipsis;
    /* Required for text-overflow to do anything */
    white-space: nowrap;
    overflow: hidden;
    padding: 0 10px;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    color: var(--spreadsheet-cell-text);
}

@media (hover: hover) {
    .CellContent:not(.ignoreHover):hover {
        background-color: var(--spreadsheet-cell-background-hover) !important;
        color: var(--spreadsheet-cell-text-hover);
    }
}

.CellCopy {
    border: 3px solid var(--primary-color);
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: copy;
}

.selectedRow, .selectedRow:hover, .selectedRow .Sticky, .selectedRow:hover .Sticky {
    background-color: var(--spreadsheet-cell-background-hover) !important;
    color: var(--spreadsheet-cell-text-hover);
}

.editBox {
    background: none;
    border: none;
    color: inherit;
    font: inherit;
    outline: none;
}

.noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Firefox */ /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}
`, "",{"version":3,"sources":["webpack://./src/app/components/datatable/spreadsheet.cell.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI;QACI,qEAAqE;QACrE,yCAAyC;IAC7C;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,qEAAqE;IACrE,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,YAAY,EACb,2BAA2B;IAClD,iBAAiB,EAAE,kEAAkE;AACzF","sourcesContent":[".CellContent {\n    text-overflow: ellipsis;\n    /* Required for text-overflow to do anything */\n    white-space: nowrap;\n    overflow: hidden;\n    padding: 0 10px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: relative;\n    color: var(--spreadsheet-cell-text);\n}\n\n@media (hover: hover) {\n    .CellContent:not(.ignoreHover):hover {\n        background-color: var(--spreadsheet-cell-background-hover) !important;\n        color: var(--spreadsheet-cell-text-hover);\n    }\n}\n\n.CellCopy {\n    border: 3px solid var(--primary-color);\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    cursor: copy;\n}\n\n.selectedRow, .selectedRow:hover, .selectedRow .Sticky, .selectedRow:hover .Sticky {\n    background-color: var(--spreadsheet-cell-background-hover) !important;\n    color: var(--spreadsheet-cell-text-hover);\n}\n\n.editBox {\n    background: none;\n    border: none;\n    color: inherit;\n    font: inherit;\n    outline: none;\n}\n\n.noselect {\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
